import { render } from "./RegisterPage.vue?vue&type=template&id=cf06fa90&ts=true"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__